import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/* -----------------------------
   INTERFACES
------------------------------ */

export interface DisciplineItem {
  id: number;
  idStudent: number;
  batchId: number;
  userId: number;
  date?: string;
  comments?: string;
  type: string;
  nameMatiere?: string;
  dateFlag?: string;
  horaire?: string;
  nameTeacher?: string;
}

export interface AdminPunitionItem {
  id: number;
  idStudent: number;
  type: string;
  date?: string;
  description?: string;
}

export interface AdminDisciplineItem {
  id: number;
  idStudent: number;
  type: string;
  details?: string;
  date?: string;
  description?: string;
}

export interface PunishementType {
  id: number;
  name: string;
  type: string;
}

/**
 * Correspond exactement à la réponse de l’API /api/punishement/listPunishementStudent
 */
export interface PunitionItem {
  id: number;
  name: string;
  punishementDescription: string;
  vu: string;
  nameMatiere: string;
  nameTeacher: string;
  horaire: string;
  creationDate: string;
}

export interface ApiResponse<T> {
  response: T[];
  error?: string;
}

/* -----------------------------
   SERVICE
------------------------------ */

@Injectable({
  providedIn: 'root',
})
export class DisciplineService {
  private baseUrl = environment.apiUrl.replace(/\/api\/?$/, '');

  constructor(private http: HttpClient) {}

  /**
   * 📘 Liste des disciplines d’un étudiant
   */
  getDisciplinePerPage(
    idStudent: number,
    batchId: number,
    userId: number,
    page = 1,
    limit = 20
  ): Observable<ApiResponse<DisciplineItem>> {
    const url = `${this.baseUrl}/api/discipline/listDisciplineStudent/${idStudent}/${batchId}/${userId}/${page}/${limit}`;
    return this.http.get<ApiResponse<DisciplineItem>>(url);
  }

  /**
   * ⚠️ Liste des punitions d’un étudiant (POST)
   * Selon la documentation API fournie.
   */
  getPunitionPerPage(
    nameOrg: string,
    idOrganization: number,
    idStudent: number,
    idBatch: number,
    idUser: number,
    numberPage = 1,
    sizePage = 1000
  ): Observable<ApiResponse<PunitionItem>> {
    const body = {
      nameOrg,
      idOrganization,
      idStudent,
      idBatch,
      idUser,
      numberPage,
      sizePage,
    };

    const url = `${this.baseUrl}/api/punishement/listPunishementStudent`;
    return this.http.post<ApiResponse<PunitionItem>>(url, body);
  }
}
